export default __webpack_public_path__ + "static/blob-44-d2708b729239027ab5bc40d09b06b798.svg";